import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { clearCsvFile } from "../../../urlFilters.actions";
import { Icon } from "../../../../../components/icon/Icon";
import { getUploadUrlState } from "../../../urlFilters.selectors";
import { useIntlTranslate } from "../../../../../hooks";

import "./CsvFileInfo.scss";

export const CsvFileInfo = () => {
  const dispatch = useDispatch();
  const translate = useIntlTranslate();
  const { siteList, fileName } = useSelector(getUploadUrlState);
  const sitesCount = siteList.length;

  return (
    <Fragment>
      <span className="upload-csv__fileName">{fileName}</span>
      <div className="upload-csv__description">
        {sitesCount > 0 && (
          <Fragment>
            <FormattedMessage
              id={"csv_domains_counter"}
              values={{ count: sitesCount }}
            />
          </Fragment>
        )}
        <button
          className="upload-csv__clear-input"
          aria-label={translate("aria_clear_csv_input")}
          onClick={() => dispatch(clearCsvFile())}
        >
          <Icon icon="fa-times fa-regular" />
        </button>
      </div>
    </Fragment>
  );
};
